module.exports = __webpack_public_path__ + "img/world.58e07a1f.svg";